module.exports = __webpack_public_path__ + "static/img/5.9d4498a.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/5.png
// module id = yFuf
// module chunks = 1